<!--
For when we will need multple tabs
<mat-card>
  <mat-tab-group mat-stretch-tabs (selectedTabChange)="tabChanged($event)">
    <mat-tab label="Scientific Rigour">
      <ng-container *ngIf="(scientificRigourPlayers$ | async) as scientificRigourPlayers">
        <app-player-list name="Scientific Rigour" [columns]="scientificRigourColumns"
          [data]="scientificRigourPlayers" [totalPlayers]="scientificRigourPlayers.length">
        </app-player-list>
      </ng-container>
    </mat-tab>
  </mat-tab-group>
</mat-card> -->

@if (scientificRigourPlayers$ | async; as scientificRigourPlayers) {
  <app-player-list
    name="Scientific Rigour"
    [columns]="scientificRigourColumns"
    [data]="scientificRigourPlayers"
    [totalPlayers]="scientificRigourPlayers.length"
    [showDownloadButton]="true"
    [worksheetColumns]="scientificRigourWorksheetColumns"
    >
  </app-player-list>
}
